import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { numbersOnly } from '@core/utils/helpers';

@Directive({
  selector: '[appNumbersOnlyInput]',
  standalone: true
})
export class NumbersOnlyInput {
  readonly #ngControl = inject(NgControl);

  @HostListener('input', ['$event.target', '$event.target.value'])
  onInput(element: HTMLInputElement | HTMLTextAreaElement, value: string): void {
    this.setNumbersOnlyInputValue(element, value);
  }

  @HostListener('blur', ['$event.target', '$event.target.value'])
  onBlur(element: HTMLInputElement | HTMLTextAreaElement, value: string): void {
    this.setNumbersOnlyInputValue(element, value);
  }

  private setNumbersOnlyInputValue(element: HTMLInputElement | HTMLTextAreaElement, value: string) {
    const numbersOnlyInputValue = numbersOnly(value);

    element.value = numbersOnlyInputValue;

    this.#ngControl.control.patchValue(numbersOnlyInputValue);
  }
}
